export type QueryParams = Record<string, string | string[] | undefined | null>;

export function updateQueryString(query: string, params: QueryParams): string {
  const raw = query.startsWith('?') ? query.slice(1) : query;
  const search = new URLSearchParams(raw);

  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) {
      search.delete(key);
    } else {
      search.set(key, Array.isArray(value) ? JSON.stringify(value) : value);
    }
  }

  const result = search.toString();
  return result ? `?${result}` : '';
}
